import { jsx as o } from "react/jsx-runtime";
import { Box as s } from "@mui/material";
import m from "@mui/material/Card";
import { makeStyles as d } from "tss-react/mui";
import i from "./CardBase.style.js";
const f = d()(i);
function l({ children: r, ...t }) {
  return /* @__PURE__ */ o(s, { ...t, children: r });
}
function u({ children: r, ...t }) {
  return /* @__PURE__ */ o(s, { ...t, children: r });
}
function C({ children: r, ...t }) {
  return /* @__PURE__ */ o(s, { ...t, children: r });
}
const e = ({
  children: r,
  className: t = "",
  ...n
}) => {
  const { classes: a } = f(), c = `${a.card} ${t}`;
  return /* @__PURE__ */ o(m, { className: c, ...n, children: r });
};
e.Header = C;
e.Content = u;
e.Actions = l;
export {
  e as CardBase,
  e as default
};
